import { Color, getDefaultTransition } from '@billy/design-system'
import { transparentize } from 'polished'

export default {
  table: {
    boxShadow: `0 2px 1px ${Color.Grey150}`,

    thead: {
      borderBottom: `1px solid ${Color.Grey150}`,

      tr: {
        boxShadow: `0 1px 3px ${transparentize(0.8, Color.Grey500)}`,
        color: Color.Black,
      },
    },
    tbody: {
      cursor: 'pointer',
    },
    tr: {
      borderBottom: `1px solid ${Color.Grey150}`,
      transition: getDefaultTransition('background'),
    },
    td: {
      padding: 1,
    },
    'tbody tr:hover, tbody tr:hover > *': {
      background: transparentize(0.75, Color.Grey300),
    },
  },
}
